import { Controller } from "@hotwired/stimulus";

// Controls showing/hiding metric and imperial weight fields
export default class extends Controller {
  static targets = ["imperialFields", "metricFields"];

  declare imperialFieldsTargets: HTMLElement[];
  declare metricFieldsTargets: HTMLElement[];

  connect() {
    this.toggleFields();
  }

  toggleFields() {
    const select = this.element.querySelector<HTMLSelectElement>('select[name="weight_unit"]');
    if (!select) return;
    if (select.value === "kg") {
      this.showMetric();
      this.hideImperial();
    } else {
      this.showImperial();
      this.hideMetric();
    }
  }

  showMetric() {
    this.metricFieldsTargets.forEach((el) => (el.style.display = ""));
  }

  hideMetric() {
    this.metricFieldsTargets.forEach((el) => (el.style.display = "none"));
  }

  showImperial() {
    this.imperialFieldsTargets.forEach((el) => (el.style.display = ""));
  }

  hideImperial() {
    this.imperialFieldsTargets.forEach((el) => (el.style.display = "none"));
  }
}

